export abstract class EventBus {
    abstract readonly type: string;
}

export class UnauthorizedEventBus extends EventBus {
    readonly type = "unauthorized";
}

export class DoneLogoutEventBus extends EventBus {
    readonly type = "done-logout";
}
